const banner = {
  "banner_01_title": "DEFINE<span>®</span>CLASSIC<br /><em>經典大地色系</em>",
  "banner_02_title": "DEFINE<span>®</span>FRESH<br /><em>大自然色系</em>",
  "banner_01_content": "經典大地色調，瞬間提亮深邃明眸，呈現炫目本色",
  "banner_02_content": "玩味大自然色調，打造精緻大眼，演繹你的「睛」彩生活",
  "banner_button_01": "虛擬試戴",
  "banner_button_02": "探索DEFINE®",
}

export default banner